export const getOriginalItem = (itemsArray: any[], itemId: number) => {
  return itemsArray.find((item) => item.READONLY_ID === itemId);
};
